import { useTableSelector } from '../../redux/reduxHooks';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableTopBar = ({
  BulkActionsComponent,
  headerLeftSlot,
  headerRightSlot,
  totalRowCount,
  alternateHeaderLeftSlot
}) => {
  const shouldShowBulkActions = useTableSelector(getShouldShowBulkActionsContainer);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-field-default",
    blockSize: TABLE_TOP_BAR_HEIGHT,
    borderColor: "border-core-default",
    borderStyle: "solid",
    borderWidth: "100",
    borderBlockEndWidth: "0",
    flexBasis: TABLE_TOP_BAR_HEIGHT,
    inlineSize: "100%",
    justifyContent: "start",
    "data-test-id": "table-top-bar",
    children: [headerLeftSlot, !shouldShowBulkActions && alternateHeaderLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      totalRowCount: totalRowCount
    }), /*#__PURE__*/_jsx("div", {
      className: "m-left-auto",
      children: headerRightSlot
    })]
  });
};
export default TableTopBar;